import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=350f1174"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=350f1174&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350f1174')) {
      api.createRecord('350f1174', component.options)
    } else {
      api.reload('350f1174', component.options)
    }
    module.hot.accept("./ProductList.vue?vue&type=template&id=350f1174", function () {
      api.rerender('350f1174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ProductList.vue"
export default component.exports